import React from 'react';
import { QTypeIcon1, QTypeIcon2, QTypeIcon3, QTypeIcon4} from '../resource/icons';
import {Icon} from 'antd'

export const questionsConstants = {    

    questionTypeIcon : (type, size) => { 
        switch (type){
          case 1: { return <img src='img/qt/1.svg' style={{height: size, verticalAlign: 'middle'}} /> }
          case 2: { return <img src='img/qt/2.svg' style={{height: size, verticalAlign: 'middle'}}/> }
          case 3: { return <img src='img/qt/3.svg' style={{height: size, verticalAlign: 'middle'}}/> }
          case 4: { return <img src='img/qt/4.svg' style={{height: size, verticalAlign: 'middle'}}/> }
          default: return <div></div>
        }
      },

    questionStateIcon : (type, size, style) => { 
        switch (type){
          case 1: { return <Icon type="question-circle" theme="twoTone" 
            style={{fontSize: size, verticalAlign: 'text-top', ...style}} /> }
          case 2: { return <Icon type="check-circle" theme="twoTone" 
            style={{fontSize: size, verticalAlign: 'text-top', ...style}}/> }
          case 3: { return <Icon type="pause-circle" theme="twoTone" 
            style={{fontSize: size, verticalAlign: 'text-top', ...style}}/> }
          default: return <div></div>
        }
      },

    CLOSE_FILTER: 'QUESTIONS_CLOSE_FILTER',
    RESET_FILTER: 'QUESTIONS_RESET_FILTER',
    FETCH_QUESTIONS: 'QUESTIONS_FETCH',
    FETCH_ADDR_STREET: 'FETCH_ADDR_STREET',
    FETCH_ADDR_BUILDING: 'QUESTIONS_FETCH_ADDR_BUILDING', 
    FETCH_ADDR_FLAT: 'QUESTIONS_FETCH_ADDR_FLAT', 
    FETCH_TYPES: 'QUESTION_FETCH_TYPES', 
    FETCH_STATES: 'QUESTION_FETCH_STATES', 
    SET_SELECTED: 'QUESTIONS_SET_SELECTED',
    SET_DATE_RANGE: 'QUESTIONS_SET_DATE_RANGE',
    SET_FILTER_COMPANY: 'QUESTIONS_SET_FILTER_COMPANY',
    SET_ADDR_BUILDING_VALUE: 'QUESTIONS_SET_ADDR_BUILDING_FILTER_VALUE', 
    SET_ADDR_FLAT_VALUE: 'QUESTIONS_SET_ADDR_FLAT_FILTER_VALUE',
    SET_SEARCH: 'QUESTIONS_SET_SEARCH',
    APPLY_ADDR_STREET: 'QUESTIONS_APPLY_ADDR_STREET_FILTER', 
    FETCH_MESSAGES: 'QUESTIONS_FETCH_MESSAGES',
    POST_ERROR: 'QUESTIONS_POST_ERROR',
    POST_MESSAGE: 'QUESTIONS_POST_MESSAGE',
    APPLY_TYPE: 'QUESTION_APPLY_TYPE',
    APPLY_STATE: 'QUESTION_APPLY_STATE',
    APPLY_NEED_ANSWER: 'QUESTION_APPLY_NEED_ANSWER',
    APPLY_COMPANY: 'QUESTION_APPLY_COMPANY',


    CLOSE_REPORT: 'CLOSE_REPORT',
    FETCH_EXPIRED_REQUESTS: 'FETCH_EXPIRED_REQUESTS',
    APPLY_WORKER: 'APPLY_WORKER',
    APPLY_STATUS: 'APPLY_STATUS',
    APPLY_SERVICE: 'APPLY_SERVICE_FILTER',
    APPLY_ADDR_BUILDING: 'APPLY_ADDR_BUILDING',
    APPLY_WARRANTY: 'APPLY_WARRANTY',
    APPLY_NOT_WARRANTY: 'APPLY_NOT_WARRANTY',
    APPLY_POSS_WARRANTY: 'APPLY_POSS_WARRANTY',
    APPLY_RETRY: 'APPLY_RETRY',
    APPLY_CHARGEABLE: 'APPLY_CHARGEABLE',
    APPLY_EXPIRED_ONLY: 'APPLY_EXPIRED_ONLY',
    APPLY_USER_CREATED: 'APPLY_USER_CREATED',
    APPLY_IMMEDIATE: 'APPLY_IMMEDIATE',
    APPLY_BADWORK: 'APPLY_BADWORK',
    APPLY_DISTRICT: 'APPLY_DISTRICT',
    SET_DATE_RANGE_FIELD: 'SET_DATE_RANGE_FIELD',
    SET_REPORTS: 'SET_REPORTS',
    SET_FILTER_WORKER: 'REQUESTS_SET_FILTER_WORKER',
    SET_FILTER_EXECUTER: 'SET_FILTER_EXECUTER',
    SET_FILTER_STATUS: 'REQUESTS_SET_FILTER_STATUS',
    SET_FILTER_SERVICE: 'REQUESTS_SET_FILTER_SERVICE', 
    SET_FILTER_DISTRICT: 'SET_FILTER_DISTRICT',
    SET_SUBSERVICE_VALUE: 'SET_SUBSERVICE_FILTER_VALUE', 
    SET_PHONE_VALUE: 'SET_PHONE_FILTER_VALUE',
    SET_RATING_VALUE: 'SET_RATING_FILTER_VALUE',
    SEARCH_REQUEST_BY_NUMBER: 'SEARCH_REQUEST_BY_NUMBER',
    UNSET_RESORT: 'UNSET_RESORT',
    SET_REQUEST_RATING: 'SET_REQUEST_RATING',
    SET_REQUEST_STATUS: 'SET_REQUEST_STATUS',
    SET_REQUEST_EXECUTE_TIME: 'SET_REQUEST_EXECUTE_TIME',
    SET_REQUEST_EXECUTER: 'SET_REQUEST_EXECUTER',
    SET_REQUEST_MASTER: 'SET_REQUEST_MASTER',
    SET_REQUEST_SERVICE: 'SET_REQUEST_SERVICE',
    SET_REQUEST_ADDRESS: 'SET_REQUEST_ADDRESS',
    MARK_REQUEST_VIEWED: 'MARK_REQUEST_VIEWED',
    MARK_REQUEST_COMMENTED: 'MARK_REQUEST_COMMENTED',
    SHOW_PREVIEW: 'SHOW_PREVIEW',
    HIDE_PREVIEW: 'HIDE_PREVIEW',
};
